import { createFileRoute } from '@tanstack/react-router'

import { TourProjectReporter } from '@/modules/getting-started'
import { ProjectLayout, ProjectProvider } from '@/modules/projects'

export const Route = createFileRoute('/_authenticated/projects/$slug')({
  staticData: { dynamicTitle: true },
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()

  return (
    <ProjectProvider>
      <ProjectLayout slug={slug} />
      <TourProjectReporter />
    </ProjectProvider>
  )
}
